"use client";
import * as React from "react";
const SvgHomeSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.4 14V9.06h3.2V14h4V7.41H16L8 0 0 7.41h2.4V14z" }));
export {
  SvgHomeSharp as default
};
